import "core-js/modules/es.array.push.js";
const __default__ = {
  name: "EditConfirm",
  data: () => ({
    subject: "",
    scheduled_for: "",
    isLoading: {
      status: true,
      message: ""
    },
    processMessage: false
  }),

  created() {
    this.setData();
  },

  methods: {
    setData() {
      getData("messages/" + this.$route.params.id + "?with=content").then(data => {
        let jpIndex = data.items[0].content.findIndex(({
          locale
        }) => locale === "ja-JP");
        this.subject = data.items[0].content[jpIndex].subject;
        this.scheduled_for = moment(data.items[0].call_scheduled_for).format("YYYY年MM月DD日 HH:mm");
      }).catch(error => {
        console.log(error);
      }).then(() => {
        this.isLoading.status = false;
      });
    },

    openEditor() {
      this.processMessage = "予約取り消し中…しばらくおまちください";
      deleteData("eraser/delete_message_reservation/" + this.$route.params.id).then(() => {
        this.processMessage = "取り消し完了。編集画面を開いています…";
        setTimeout(() => {
          this.$router.push({
            name: "messages.edit",
            params: {
              id: this.$route.params.id
            }
          });
        }, 1000);
      }).catch(error => {
        console.log(error);
      });
    }

  }
};
import { deleteData, getData } from "@/services/axios";
import moment from "moment";
import LoadingMessage from "@/components/common/LoadingMessage.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    return {
      __sfc: true,
      LoadingMessage
    };
  }

});